/* Rince — micro-interacties (paart met rince-micro.css).
   Delegation op document-niveau: overleeft sectie-morphs en de theme editor.
   1) druppel-ripple vanaf het klikpunt op primaire knoppen
   2) swatch-pop bij het kiezen van een kleur/optie
   3) totaal-bump zodra de count-up landt (debounced tekst-observer)
   4) glans op de verzendbalk zodra gratis verzending is bereikt */
(function () {
  'use strict';
  if (window.__rxMicroInit) return;
  window.__rxMicroInit = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1) druppel-ripple ─────────────────────────────────────────────────── */
  var RIPPLE = '.hx-btn, .rx-mini__add, .rx-builder__add, .rince-sticky-bar__buy, .hx-wc-btn, .hx-wc-email-btn, .hx-nav-btn';
  document.addEventListener('pointerdown', function (e) {
    if (reduce || !e.target || !e.target.closest) return;

    var btn = e.target.closest(RIPPLE);
    if (btn) {
      btn.classList.add('rx-rippled');
      var r = btn.getBoundingClientRect();
      var d = Math.max(r.width, r.height) * 2.1;
      var s = document.createElement('span');
      s.className = 'rx-ripple';
      s.style.width = s.style.height = d.toFixed(0) + 'px';
      s.style.left = (e.clientX - r.left).toFixed(0) + 'px';
      s.style.top = (e.clientY - r.top).toFixed(0) + 'px';
      btn.appendChild(s);
      s.addEventListener('animationend', function () { s.remove(); });
      setTimeout(function () { if (s.parentNode) s.remove(); }, 900); // vangnet
    }

    /* ── 2) swatch-pop ── */
    var sw = e.target.closest('.rx-builder__sw, .rx-color__opt, .sw');
    if (sw) {
      sw.classList.remove('rx-pop');
      void sw.offsetWidth; // herstart de animatie
      sw.classList.add('rx-pop');
      sw.addEventListener('animationend', function h() { sw.classList.remove('rx-pop'); sw.removeEventListener('animationend', h); });
    }
  }, { passive: true });

  /* ── 3) totaal-bump: tik zodra de teller tot rust komt ─────────────────── */
  function watchTotal(el) {
    if (el.__rxWatched) return;
    el.__rxWatched = true;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (reduce) return;
        el.classList.remove('rx-bump');
        void el.offsetWidth;
        el.classList.add('rx-bump');
      }, 260); // wacht tot de count-up klaar is
    }).observe(el, { characterData: true, childList: true, subtree: true });
  }

  /* ── 4) verzendbalk-glans bij 100% ─────────────────────────────────────── */
  function watchShip(el) {
    if (el.__rxWatched) return;
    el.__rxWatched = true;
    new MutationObserver(function () {
      var full = parseFloat(el.style.width) >= 100;
      if (full && !el.__rxShone) {
        el.__rxShone = true;
        if (!reduce) {
          el.classList.add('rx-shine');
          setTimeout(function () { el.classList.remove('rx-shine'); }, 1000);
        }
      } else if (!full) {
        el.__rxShone = false;
      }
    }).observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  function scan() {
    document.querySelectorAll('[data-rx-total], .rince-sticky-bar__price').forEach(watchTotal);
    document.querySelectorAll('[data-rx-ship-fill]').forEach(watchShip);
  }
  document.addEventListener('shopify:section:load', scan);
  // na een variantwissel morpht Horizon de sectie → verse elementen opnieuw aanhaken
  document.addEventListener('variant:update', function () { setTimeout(scan, 350); });
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
})();
